import * as types from "./mutation-types";

const mutations = {
    [types.SET_SCALES]: (state, payload) => {
        state.scales = payload.data;
    },
    [types.SET_SCALE_HOUSES]: (state, payload) => {
        state.scale_houses = payload.data;
    },
    [types.SET_SCALE_MEASUREMENTS]: (state, payload) => {
        state.scale_measurements = Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload)
                ? payload
                : [];
    },
    [types.SET_VEHICLE_CONFIGURATIONS]: (state, payload) => {
        state.weighing_on_scale_vehicle_conf = payload.data;
    },
    [types.SET_WEIGHING_TYPES]: (state, payload) => {
        state.weighing_on_scale_types = payload.data;
    },
}

export default mutations;
